import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'AddAddressForm';

/**
 * Errors related to the Addresses/Autpoship Address page
 */
export const Errors = createErrors<Page, Component>('AddressBook')({
    AddAddressForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to add address',
        },
        SubscriptionSyncFailed: {
            severity: 'MEDIUM',
            message: 'Address saved but subscription orders sync failed',
        },
        RemoveAddressFailed: {
            severity: 'HIGH',
            message: 'Failed to remove address',
        },
    },
    AddressList: {
        ChangeShippingAddress: {
            severity: 'HIGH',
            message: 'Failed to change shipping address',
        },
        FaildToGetFraudValidationNeeded: {
            severity: 'HIGH',
            message: 'Failed to get fraud validation needed',
        },
    },
});
